import Ensaladas from '../global/img/entradas/Ensaladas.jpg';
import Entradas from '../global/img/entradas/Entradas.jpg';
import Pastas from '../global/img/entradas/Pastas.jpg';
import PlatosFuertes from '../global/img/entradas/PlatosFuertes.jpg';
import Postres from '../global/img/entradas/Postres.jpg';
import Pizzas from '../global/img/entradas/Pizzas.jpg';
import Clericot from '../global//img/entradas/Clericot.jpg';

export const categorias = [
  {
    tipo: 'carta_alimentos',
    nombre: 'Entradas',
    img: Entradas,
  },
  {
    tipo: 'carta_alimentos',
    nombre: 'Ensaladas',
    img: Ensaladas,
  },
  {
    tipo: 'carta_alimentos',
    nombre: 'Pastas',
    img: Pastas,
  },
  {
    tipo: 'carta_alimentos',
    nombre: 'Platos fuertes',
    img: PlatosFuertes,
  },
  {
    tipo: 'carta_alimentos',
    nombre: 'Pizzas',
    img: Pizzas,
  },
  {
    tipo: 'carta_alimentos',
    nombre: 'Postres',
    img: Postres,
  },
  {
    tipo: 'carta_alimentos',
    nombre: 'Clericot',
    img: Clericot,
  },
];
